import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * Process Event Schema
 *
 * Thin mutation-response projection of a draft event node: the `_id` plus
 * the editable content trio. Returned by the draft event mutations
 * (`add-draft-event`, `update-draft-event`, `upgrade-draft-event-input`) so
 * the editor can patch its cache without a refetch. The full node rows —
 * with `eventKind` — travel as `ProcessDraftEventNodeSchema` on the draft
 * response and `ProcessEventNodeSchema` on show-process
 * (ADR 0003). Kept as its own object rather than a `.pick` of the node
 * schema because `_id` stays ObjectId-validated here, while node rows use a
 * plain string id.
 */ export const ProcessEventSchema = z.object({
    _id: ObjectIdSchema,
    eventType: z.string(),
    name: z.string(),
    description: z.string()
});

//# sourceMappingURL=process-event.schema.js.map